import { render } from "./FeaturedBrandsComponent.vue?vue&type=template&id=2d119490"
import script from "./FeaturedBrandsComponent.vue?vue&type=script&lang=js"
export * from "./FeaturedBrandsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"platform/themes/staderecord/assets/js/components/FeaturedBrandsComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2d119490"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2d119490', __exports__)) {
    api.reload('2d119490', __exports__)
  }
  
  module.hot.accept("./FeaturedBrandsComponent.vue?vue&type=template&id=2d119490", () => {
    api.rerender('2d119490', render)
  })

}


export default __exports__